import type { AnalyticsTab } from "./analyticsTabs";

const ANALYTICS_SUBTAB_QUERY_PARAMS: Record<AnalyticsTab, string[]> = {
  overview: [],
  revenue: [],
  services: ["segment"],
  offers: ["offersStage"],
  reviews: ["reviewsSegment"],
  operations: [],
  team: ["teamSegment", "staffId", "teamId"],
};

const ALL_ANALYTICS_SUBTAB_QUERY_PARAMS = Array.from(
  new Set(Object.values(ANALYTICS_SUBTAB_QUERY_PARAMS).flat()),
);

export function clearInactiveAnalyticsSubTabParams(
  params: URLSearchParams,
  activeTab: AnalyticsTab,
): URLSearchParams {
  const nextParams = new URLSearchParams(params);
  const activeParams = new Set(ANALYTICS_SUBTAB_QUERY_PARAMS[activeTab]);

  for (const key of ALL_ANALYTICS_SUBTAB_QUERY_PARAMS) {
    if (!activeParams.has(key)) {
      nextParams.delete(key);
    }
  }

  return nextParams;
}
